<template>
    <div
        class="flex flex-col overflow-hidden rounded-lg shadow-sm bb-component-background"
    >
        <div class="flex-none w-full" v-if="this.data.img_url">
            <img
                :src="this.data.img_url"
                class="inset-0 w-full h-full object-cover rounded-t-md"
            />
        </div>
        <div class="px-3 py-3 sm:px-3 pb-0"
             v-if="this.data.heading || this.data.template_heading || this.data.subheading || this.data.template_subheading">
            <h2
                v-if="this.data.heading || this.data.template_heading"
                class="mb-0 bb-component-heading"
            >
                {{ this.data.heading || this.data.template_heading }}
            </h2>
            <div
                v-if="this.data.subheading || this.data.template_subheading"
                class="mb-0 bb-component-subheading"
            >
                {{ this.data.subheading || this.data.template_subheading }}
            </div>
        </div>
        <div class="p-3" v-if="this.data.content || this.data.template_content">
            <div
                class="bb-component-content"
                v-html="parsedContent(this.data.content) || parsedContent(this.data.template_content)"
            >
            </div>
        </div>
        <div class="flex flex-row-reverse p-3 pt-0" v-if="this.data.cta_url">
            <a v-if="isUrlAbsolute(this.data.cta_url)" :href="this.data.cta_url"
               class="w-auto py-1 px-3 rounded-lg flex items-center justify-center bb-component-button">{{ this.data.cta_text
                }}</a>
            <router-link v-else :to="this.data.cta_url"
                         class="w-auto py-1 px-3 rounded-lg flex items-center justify-center bb-component-button">
                {{ this.data.cta_text }}
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Card",
    props: {
        data: {
            type: Object,
            default: null
        }
    },
    methods: {
        isUrlAbsolute(url) {
            return url.indexOf("http://") === 0 || url.indexOf("https://") === 0;
        },
        parsedContent(content) {
            return content.replace(/&amp;/g, '&')
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, '>')
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
        }
    }
};
</script>
<style>
img {
    pointer-events: none;
}
</style>
